module.exports = __webpack_public_path__ + "img/prep-2.c6aaf6a8.jpg";